import abstractBlue from './images/abstract_blue.png';
import abstractGray from './images/abstract_gray.png';
import abstractLime from './images/abstract_lime.png';
import abstractOrange from './images/abstract_orange.png';
import abstractPurple from './images/abstract_purple.png';
import abstract2Blue from './images/abstract_2_blue.png';
import abstract2Gray from './images/abstract_2_gray.png';
import abstract2Lime from './images/abstract_2_lime.png';
import abstract2Orange from './images/abstract_2_orange.png';
import abstract2Purple from './images/abstract_2_purple.png';
import cloudBlue from './images/cloud_blue.png';
import cloudGray from './images/cloud_gray.png';
import cloudLime from './images/cloud_lime.png';
import cloudOrange from './images/cloud_orange.png';
import cloudPurple from './images/cloud_purple.png';
import defaultBlue from './images/default_blue.png';
import defaultGray from './images/default_gray.png';
import defaultLime from './images/default_lime.png';
import defaultOrange from './images/default_orange.png';
import defaultPurple from './images/default_purple.png';
import default2Blue from './images/default_2_blue.png';
import default2Gray from './images/default_2_gray.png';
import default2Lime from './images/default_2_lime.png';
import default2Orange from './images/default_2_orange.png';
import default2Purple from './images/default_2_purple.png';
import devBlue from './images/dev_blue.png';
import devGray from './images/dev_gray.png';
import devLime from './images/dev_lime.png';
import devOrange from './images/dev_orange.png';
import devPurple from './images/dev_purple.png';
import launchBlue from './images/launch_blue.png';
import launchGray from './images/launch_gray.png';
import launchLime from './images/launch_lime.png';
import launchOrange from './images/launch_orange.png';
import launchPurple from './images/launch_purple.png';
import meetingsBlue from './images/meetings_blue.png';
import meetingsGray from './images/meetings_gray.png';
import meetingsLime from './images/meetings_lime.png';
import meetingsOrange from './images/meetings_orange.png';
import meetingsPurple from './images/meetings_purple.png';

const HEADER_IMAGES: string[] = [
	abstractBlue,
	abstractPurple,
	abstractLime,
	abstractOrange,
	abstractGray,
	abstract2Blue,
	abstract2Purple,
	abstract2Lime,
	abstract2Orange,
	abstract2Gray,
	cloudBlue,
	cloudPurple,
	cloudLime,
	cloudOrange,
	cloudGray,
	defaultBlue,
	defaultPurple,
	defaultLime,
	defaultOrange,
	defaultGray,
	default2Blue,
	default2Purple,
	default2Lime,
	default2Orange,
	default2Gray,
	devBlue,
	devPurple,
	devLime,
	devOrange,
	devGray,
	launchBlue,
	launchPurple,
	launchLime,
	launchOrange,
	launchGray,
	meetingsBlue,
	meetingsPurple,
	meetingsLime,
	meetingsOrange,
	meetingsGray,
];

/**
 * Simple hash function that converts a string to a numeric hash.
 * Uses a multiplicative hash for good distribution.
 */
const hashString = (str: string): number => {
	let hash = 5381;
	for (let i = 0; i < str.length; i++) {
		hash = Math.abs((hash * 33 + str.charCodeAt(i)) % 2147483647);
	}
	return hash;
};

/**
 * Returns a deterministic header image URL for a given account ID.
 * The same account ID will always produce the same image.
 */
export const getHeaderImage = (accountId: string): string => {
	const index = hashString(accountId) % HEADER_IMAGES.length;
	return HEADER_IMAGES[index];
};
